import axios from "axios";
import { ElMessageBox } from "element-plus";

import qs from "qs";

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

const request = axios.create({
  baseURL: "/",
  responseType: "json",
  params: __type__ === 'traffic' ? {} : {
    ieTime: Date.now(),
  },
});

const get = (url, params) => {
  return new Promise((resolve, reject) => {
    request
      .get(url, { params })
      .then((res) => resolve(res.data))
      .catch((e) => {
        ElMessageBox.alert(e, "提示", {
          confirmButtonText: "确定",
          type: "error",
        });
        reject && reject(e);
      });
  });
};

const post = (url, data, params) => {
  return new Promise((resolve, reject) => {
    request
      .post(url, qs.stringify({ data }), { params })
      .then((res) => resolve(res.data))
      .catch((e) => {
        ElMessageBox.alert(e, "提示", {
          confirmButtonText: "确定",
          type: "error",
        });
        reject && reject(e);
      });
  });
};

const form = (url, data) => {
  return new Promise((resolve, reject) => {
    request
      .post(url, qs.stringify(data))
      .then((res) => resolve(res.data))
      .catch((e) => {
        ElMessageBox.alert(e, "提示", {
          confirmButtonText: "确定",
          type: "error",
        });
        reject && reject(e);
      });
  });
};

export default {
  get,
  post,
  form,
};
